import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import FeatureGates, { FeatureGateEnvironment } from '@atlassian/feature-gate-js-client';
export { FeatureGateEnvironment as StatsigEnvironment };
class StatsigClient {
  constructor() {
    _defineProperty(this, "getAllStatsigFeatureGatesAndExperiments", () => {
      const experiments = {
        marketplaceTestExperimentForStatsigInt: FeatureGates.getExperimentValue('marketplace_test_experiment_for_statsig_int', 'showNewTile', false)
      };
      const featureGates = {
        enableStaffPickOnAppListing: FeatureGates.checkGate('enable_staff_pick_on_app_listing'),
        enableNewHomePageCollections: FeatureGates.checkGate('enable_new_home_page_collections')
      };

      // presently there is no way to get all feature gates from statsig
      return _objectSpread(_objectSpread({}, featureGates), experiments);
    });
  }
  // IMPORTANT: Calling this method will completely re-initialize the client with a new set of flags. You will need to re-render the entire page after this completes to ensure everything picks up the new flag values. You should avoid using this frequently as it has implications on the user experience.
  async initializeStatsigClient(_ref) {
    let {
      clientKey,
      environment,
      targetApp,
      marketplaceAnonymousId
    } = _ref;
    let customAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    try {
      await FeatureGates.initialize({
        apiKey: clientKey,
        environment,
        targetApp
      }, {
        marketplaceAnonymousId
      }, customAttributes);
    } catch (err) {
      console.error('Failed to initialize FeatureGates client.', err);
    }
  }
}
const statsigClientInstance = new StatsigClient();
export default statsigClientInstance;